import React from "react";
import styled, { css } from "styled-components";

import theme from "../../../styles/theme";

const StyledDiv = styled.div`
  width: 16px;
  height: 16px;
  top: 0px;
  right: 0px;
  &:after, &:before {
    content: ' ';
    width: 75%;
    height: 2px;
    border-radius: 3px;
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translateX(-32%) rotate(40deg);
    transform-origin: right bottom;
    background-color: ${(props) => props.fillColor || theme.colors.green3};
  }
  &:before {
    width: 75%;
    left: 50%;
    transform: translateX(0px) rotate(-40deg);
    transform-origin: left bottom;
  }
  ${props =>
    props.right &&
    css`
      margin-top: 4px;
      width: 12px;
      height: 12px;
      transform: rotate(-90deg);
    `}
  ${() => theme.media.tabletUp`
    width: 11px;
    height: 8px;
  `};
`;

export default ({ down, right, fillColor, animate }) => {
  return <StyledDiv fillColor={fillColor} down={down} right={right}>

  </StyledDiv>
};
